var React = require('react');

function StarHalf (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Star Half"),React.createElement("path",{"d":"M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z","fill":"none","stroke":"currentColor","strokeLinejoin":"round","strokeWidth":"32","key":1}),React.createElement("path",{"d":"M256 48v316L118 464l54-160-140-96h172l52-160z","fill":"currentColor","key":2})]);
}

StarHalf.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = StarHalf;

StarHalf.default = StarHalf;
